/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import React from "react";

interface ReconSearchFilterProps {
  searchTerm: string;
  searchPlaceholder: string;
  setSearchTerm: (term: string) => void;

  statusFilter?: string;
  setStatusFilter?: (status: string) => void;
}

const ReconSearchFilter: React.FC<ReconSearchFilterProps> = ({
  searchTerm,
  setSearchTerm,
  searchPlaceholder,
  statusFilter,
  setStatusFilter,
}) => {
  return (
    <div className="ml-auto flex items-center gap-3">

      {/* Search */}
      <div className="relative w-[320px]">
        <span className="material-symbols-outlined absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 text-lg">
          search
        </span>

        <input
          type="text"
          placeholder={searchPlaceholder}
          className="w-full pl-12 pr-20 py-2 bg-white border border-slate-200 rounded-xl text-xs font-medium focus:ring-4 focus:ring-orange-500/10 focus:border-orange-500 transition-all outline-none"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      {/* Status Filter */}
      {setStatusFilter && (
        <div className="relative w-[170px]">
          <select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            className={`w-full py-2 px-4 border border-slate-200 rounded-xl text-xs font-medium appearance-none outline-none bg-slate-50 ${
              statusFilter ? "text-slate-700" : "text-slate-600"
            }`}
          >
            <option value="">Status</option>
            <option value="PENDING">Pending</option>
            <option value="UP_TO_DATE">Up To Date</option>
            <option value="OVERDUE">Overdue</option>
          </select>

          <span className="material-symbols-outlined absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none text-lg">
            expand_more
          </span>
        </div>
      )}
    </div>
  );
};

export default ReconSearchFilter;